// ============================================================
// localDate.js — timezone-safe helpers for YYYY-MM-DD date strings.
//
// The Finance module (and any module storing plain date strings)
// MUST avoid the classic "midnight-UTC → previous-day-local" bug:
//   new Date("2026-07-13")            → 2026-07-13 00:00 UTC
//   .toLocaleDateString() (in ET)     → "Jul 12, 2026"  ❌
//
// These helpers work exclusively in the browser's LOCAL timezone
// so a date the user picked is the date the user sees, always.
// ============================================================

/** YYYY-MM-DD for the local "today" (never rolls a day due to UTC). */
export function todayLocalISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Parse a YYYY-MM-DD string into a local-time Date at midnight. */
export function parseLocalDate(iso) {
  if (!iso || typeof iso !== "string" || iso.length < 10) return null;
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

/** Format a YYYY-MM-DD (or ISO datetime) as a locale-friendly date string. */
export function fmtLocalDate(iso, opts = { year: "numeric", month: "short", day: "numeric" }) {
  if (!iso) return "—";
  const d = parseLocalDate(iso);
  if (!d) return iso;
  try { return d.toLocaleDateString(undefined, opts); } catch { return iso; }
}

/** YYYY-MM-DD → { year, month(0-11), day } (all local). */
export function localParts(iso) {
  const d = parseLocalDate(iso);
  if (!d) return null;
  return { year: d.getFullYear(), month: d.getMonth(), day: d.getDate() };
}
